import { Pipe, PipeTransform } from '@angular/core';
import { formatTypes } from '@zipari/shared-ds-util-format';
import { FormattingService } from '../services/formatting.service';

@Pipe({
  name: 'formatCurrency',
})
export class FormatCurrencyPipe implements PipeTransform {
  constructor(private formattingService: FormattingService) {}

  transform(amount: string | number): string {
    return amount
      ? this.formattingService.restructureValueBasedOnFormat(amount, {
          format: formatTypes.CURRENCY,
        })
      : '';
  }
}
